import React, { Component } from 'react';
import DateRange from './date-range';
import TimeRange from './time-range';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setFlightsOption } from '../../actions/flight-list';
import './styles.css';

class FlightListOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            archiveBox: false,
        }
        this.onChangeTypeRange = this.onChangeTypeRange.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.onShowFlights = this.onShowFlights.bind(this);
        this.onShowArchive = this.onShowArchive.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.dateChange = this.dateChange.bind(this);
    }

    onChangeTypeRange(event) {
        let el = event.currentTarget;
        let typeRange = el.checked ? 'time' : 'date';
        this.props.setFlightsOption({ typeRange });
    }

    onChangeInput(event) {
        // let el = event.currentTarget;
        // let change = {};
        // change[el.name] = el.value;
        // console.log(event,'hcahhsuhgiushhu')
        this.props.setFlightsOption(event);
    }
    dateChange(event) {
        let el = event.currentTarget;
        let change = {};
        change[el.name] = el.value;
        // console.log(change,'checking data on change')
        this.props.setFlightsOption(change);
    }
    onShowFlights(event) {
        const { archiveBox } = this.state
        if (archiveBox) {
            this.props.history.push(`/flights?archive=true`);
        } else {
            this.props.history.push(`/flights?archive=false`);
        }
    }
    onShowArchive(event) {
        event.preventDefault();
        if (event) {
            this.props.history.push('/flightsearch');
        } else {
            this.props.history.push(`/flights`);
        }
    };
    handleChecked() {
        let updateChecked = this.setState({ value: this.state.checked })
        alert(updateChecked);
    };
    handleChecBox(e) {
        this.setState({
            archiveBox: e.target.checked
        })

    }

    render() {
        let { dateFrom, dateTo, timeMinus, timePlus, autoRefresh } = this.props;
        let rangeInputs = this.props.typeRange === 'time' ?
            <TimeRange minus={timeMinus} plus={timePlus} onChange={this.onChangeInput} /> :
            <DateRange from={dateFrom} archiveBox={this.state.archiveBox} to={dateTo} onChange={this.onChangeInput} dateChange={this.dateChange}/>;
        return (
            <div id='flight-list-options'
                className='h-100 container-fluid'>
                <div className='row justify-content-center'>
                    <div className='col-12 my-2'>
                        <div className='d-flex justify-content-center'>
                            <span className='mr-3'>Date</span>
                            <div className='custom-control custom-switch text-center'
                                style={{ paddingLeft: '2.8rem' }}>
                                <input className='custom-control-input'
                                    id='typeRange'
                                    type='checkbox'
                                    onChange={this.onChangeTypeRange}
                                    checked={this.props.typeRange === 'time'} />
                                <label className='custom-control-label'
                                    htmlFor='typeRange'></label>
                            </div>
                            <span className='ml-3'>Time</span>
                        </div>
                        {rangeInputs}
                        <div className='form-group row'>
                            <label className='col-5 col-form-label col-form-label-sm text-right'
                                htmlFor='autoRefresh'>
                                Auto refresh every</label>
                            <div className='col-7 input-group align-items-center'>
                                <input type='number'
                                    className='form-control form-control-sm rounded-0 bg-transparent text-light'
                                    id='autoRefresh'
                                    aria-describedby=''
                                    name='autoRefresh'
                                    value={autoRefresh}
                                    onChange={this.onChangeInput}
                                    placeholder='minutes'
                                    min={1}
                                    max={9} />&nbsp;minute(s)
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className='col-5 col-form-label col-form-label-sm text-right'>Search For Archive</label>
                            <div className='col-7 input-group align-items-center'>
                                <input type="checkbox" onChange={this.handleChecBox.bind(this)} />&nbsp;<span style={{ fontSize: '12px', color: 'rgb(138 137 137)' }}>(Select check box for Archive Flight search)</span>
                            </div>
                        </div>
                        <div className='text-center'>
                            <button className='btn btn-light btn-sm' 
                                onClick={this.onShowFlights}
                            // onClick={this.onShowArchive}
                            >
                                Show Flights</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = state => ({ ...state.flights.options });

const mapActionsToProps = { setFlightsOption };

export default withRouter(connect(mapStateToProps, mapActionsToProps)(FlightListOptions));